/**
 * VIP 日期库内为 yyyy-MM-dd；空值展示为 —。仍兼容历史 8 位 yyyymmdd。
 */
function formatVipDate (value) {
  if (value == null || value === '') {
    return '—'
  }
  const text = String(value).trim()
  if (/^\d{8}$/.test(text)) {
    return text.slice(0, 4) + '-' + text.slice(4, 6) + '-' + text.slice(6, 8)
  }
  return text
}

module.exports = {
  formatVipDate
}
